import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import Select from '../../components/ui/Select';
import TripCard from './components/TripCard';
import StatsCard from './components/StatsCard';
import QuickActionCard from './components/QuickActionCard';
import SavedRouteCard from './components/SavedRouteCard';
import PaymentHistoryCard from './components/PaymentHistoryCard';
import LoyaltyCard from './components/LoyaltyCard';
import ProfileSection from './components/ProfileSection';

const UserDashboard = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');
  const [searchQuery, setSearchQuery] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');

  const userProfile = {
    name: "Rajveer Singh Gill",
    email: "rajveer.gill@email.com",
    phone: "+91 98765 43210",
    emergencyContact: "+91 98765 43211",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f39d6cda-1763295757879.png",
    avatarAlt: "Professional headshot of Sikh man with turban and warm smile wearing formal navy blue suit",
    memberSince: "15/03/2024",
    totalTrips: 24
  };

  const trips = [
  {
    id: 1,
    bookingId: "ST2026010501",
    vehicleType: "Toyota Innova Crysta",
    vehicleImage: "https://img.rocket.new/generatedImages/rocket_gen_img_10b3582ff-1764720422661.png",
    vehicleImageAlt: "White Toyota Innova Crysta luxury MPV parked in modern urban setting with glass buildings in background",
    from: "Amritsar, Punjab",
    to: "Delhi, NCR",
    date: "2026-01-08",
    time: "06:00",
    fare: 8500,
    status: "upcoming"
  },
  {
    id: 2,
    bookingId: "ST2026010402",
    vehicleType: "Force Urbania",
    vehicleImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1be0024a8-1767645973805.png",
    vehicleImageAlt: "Luxury Force Urbania van in pearl white color with chrome accents parked at premium hotel entrance",
    from: "Chandigarh, Punjab",
    to: "Manali, Himachal Pradesh",
    date: "2026-01-15",
    time: "05:30",
    fare: 15000,
    status: "upcoming"
  },
  {
    id: 3,
    bookingId: "ST2025122803",
    vehicleType: "Maruti Ertiga",
    vehicleImage: "https://img.rocket.new/generatedImages/rocket_gen_img_191a16012-1768368473200.png",
    vehicleImageAlt: "Silver Maruti Ertiga family car with sleek design parked in residential area with trees in background",
    from: "Ludhiana, Punjab",
    to: "Shimla, Himachal Pradesh",
    date: "2025-12-28",
    time: "07:00",
    fare: 6500,
    status: "completed"
  },
  {
    id: 4,
    bookingId: "ST2025121504",
    vehicleType: "Toyota Innova",
    vehicleImage: "https://images.unsplash.com/photo-1710212106058-0fe2d76246b0",
    vehicleImageAlt: "Grey Toyota Innova MPV with modern styling parked at airport terminal with clear blue sky",
    from: "Jalandhar, Punjab",
    to: "Dharamshala, Himachal Pradesh",
    date: "2025-12-15",
    time: "06:30",
    fare: 5500,
    status: "completed"
  }];


  const stats = [
  {
    icon: "Calendar",
    label: "Total Trips",
    value: "24",
    trend: "up",
    trendValue: "+12%",
    color: "primary"
  },
  {
    icon: "Clock",
    label: "Upcoming Trips",
    value: "2",
    color: "secondary"
  },
  {
    icon: "IndianRupee",
    label: "Total Spent",
    value: "₹1,85,000",
    trend: "up",
    trendValue: "+8%",
    color: "success"
  },
  {
    icon: "Award",
    label: "Loyalty Points",
    value: "2,450",
    trend: "up",
    trendValue: "+150",
    color: "accent"
  }];


  const quickActions = [
  {
    icon: "Plus",
    title: "Book New Trip",
    description: "Start planning your next journey with us",
    path: "/booking-confirmation",
    color: "primary"
  },
  {
    icon: "MapPin",
    title: "Explore Routes",
    description: "Discover popular destinations and routes",
    path: "/route-details",
    color: "secondary"
  },
  {
    icon: "Car",
    title: "View Services",
    description: "Browse our fleet and service options",
    path: "/service-selection",
    color: "success"
  },
  {
    icon: "MessageCircle",
    title: "Contact Support",
    description: "Get help with your bookings and queries",
    path: "/contact-support",
    color: "warning"
  }];


  const savedRoutes = [
  {
    id: 1,
    from: "Amritsar",
    to: "Delhi",
    distance: "450 km",
    duration: "7-8 hours",
    estimatedFare: 8500
  },
  {
    id: 2,
    from: "Chandigarh",
    to: "Manali",
    distance: "310 km",
    duration: "8-9 hours",
    estimatedFare: 12000
  },
  {
    id: 3,
    from: "Ludhiana",
    to: "Shimla",
    distance: "280 km",
    duration: "6-7 hours",
    estimatedFare: 6500
  }];


  const paymentHistory = [
  {
    id: 1,
    bookingId: "ST2026010501",
    amount: 8500,
    date: "2026-01-05",
    method: "upi",
    status: "success"
  },
  {
    id: 2,
    bookingId: "ST2026010402",
    amount: 15000,
    date: "2026-01-04",
    method: "card",
    status: "success"
  },
  {
    id: 3,
    bookingId: "ST2025122803",
    amount: 6500,
    date: "2025-12-28",
    method: "wallet",
    status: "success"
  },
  {
    id: 4,
    bookingId: "ST2025121504",
    amount: 5500,
    date: "2025-12-15",
    method: "cash",
    status: "success"
  }];


  const loyaltyData = {
    points: 2450,
    tier: "gold",
    nextTierPoints: 5000
  };

  const statusOptions = [
  { value: 'all', label: 'All Trips' },
  { value: 'upcoming', label: 'Upcoming' },
  { value: 'completed', label: 'Completed' },
  { value: 'cancelled', label: 'Cancelled' }];


  const filteredTrips = trips?.filter((trip) => {
    const matchesSearch = trip?.from?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    trip?.to?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    trip?.bookingId?.toLowerCase()?.includes(searchQuery?.toLowerCase());
    const matchesStatus = filterStatus === 'all' || trip?.status === filterStatus;
    return matchesSearch && matchesStatus;
  });

  const handleModifyTrip = (trip) => {
    navigate('/booking-confirmation', { state: { modifyTrip: trip } });
  };

  const handleCancelTrip = (trip) => {
    if (window.confirm(`Are you sure you want to cancel booking ${trip?.bookingId}?`)) {
      alert('Trip cancellation request submitted. Our team will contact you shortly.');
    }
  };

  const handleRemoveSavedRoute = (routeId) => {
    alert('Saved route removed successfully');
  };

  const handleUpdateProfile = (updatedProfile) => {
    alert('Profile updated successfully');
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/917998666660', '_blank');
  };

  const tabs = [
  { id: 'overview', label: 'Overview', icon: 'LayoutDashboard' },
  { id: 'trips', label: 'My Trips', icon: 'Calendar' },
  { id: 'saved', label: 'Saved Routes', icon: 'Bookmark' },
  { id: 'payments', label: 'Payments', icon: 'CreditCard' },
  { id: 'profile', label: 'Profile', icon: 'User' }];


  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-20 lg:pt-24 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
              <div>
                <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-2">
                  Welcome back, {userProfile?.name?.split(' ')?.[0]}! 👋
                </h1>
                <p className="text-sm md:text-base text-muted-foreground">
                  Manage your trips and explore new destinations
                </p>
              </div>
              <Button
                variant="default"
                size="lg"
                iconName="Plus"
                iconPosition="left"
                onClick={() => navigate('/booking-confirmation')}
                className="bg-action hover:bg-action/90 self-start md:self-auto">

                Book New Trip
              </Button>
            </div>

            <div className="bg-card border border-border rounded-xl p-2 overflow-x-auto scrollbar-thin">
              <div className="flex gap-2 min-w-max">
                {tabs?.map((tab) =>
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all duration-200 whitespace-nowrap ${
                  activeTab === tab?.id ?
                  'bg-primary text-primary-foreground' :
                  'text-foreground hover:bg-muted'}`
                  }>

                    <Icon name={tab?.icon} size={18} />
                    <span>{tab?.label}</span>
                  </button>
                )}
              </div>
            </div>
          </div>

          {activeTab === 'overview' &&
          <div className="space-y-8">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
                {stats?.map((stat, index) =>
              <StatsCard key={index} {...stat} />
              )}
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <div className="lg:col-span-2 space-y-6">
                  <div>
                    <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground mb-4">
                      Quick Actions
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {quickActions?.map((action, index) =>
                    <QuickActionCard key={index} {...action} />
                    )}
                    </div>
                  </div>

                  <div>
                    <div className="flex items-center justify-between mb-4">
                      <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground">
                        Upcoming Trips
                      </h2>
                      <Button
                      variant="ghost"
                      size="sm"
                      iconName="ArrowRight"
                      iconPosition="right"
                      onClick={() => setActiveTab('trips')}>

                        View All
                      </Button>
                    </div>
                    <div className="space-y-4">
                      {trips?.filter((trip) => trip?.status === 'upcoming')?.slice(0, 2)?.map((trip) =>
                    <TripCard
                      key={trip?.id}
                      trip={trip}
                      onModify={handleModifyTrip}
                      onCancel={handleCancelTrip} />

                    )}
                    </div>
                  </div>
                </div>

                <div className="space-y-6">
                  <LoyaltyCard {...loyaltyData} />

                  <div className="bg-gradient-journey rounded-xl p-6 text-white">
                    <div className="flex items-start justify-between mb-4">
                      <div>
                        <h3 className="text-lg font-heading font-semibold mb-1">
                          Need Assistance?
                        </h3>
                        <p className="text-sm opacity-90">
                          Our team is here to help 24/7
                        </p>
                      </div>
                      <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                        <Icon name="Headphones" size={20} />
                      </div>
                    </div>
                    <div className="space-y-3">
                      <Button
                      variant="outline"
                      size="sm"
                      iconName="Phone"
                      iconPosition="left"
                      onClick={() => window.open('tel:7998666660', '_self')}
                      fullWidth
                      className="bg-white/10 border-white/30 text-white hover:bg-white/20">

                        Call 7998666660
                      </Button>
                      <Button
                      variant="outline"
                      size="sm"
                      iconName="MessageCircle"
                      iconPosition="left"
                      onClick={handleWhatsAppClick}
                      fullWidth
                      className="bg-white/10 border-white/30 text-white hover:bg-white/20 whatsapp-pulse">

                        WhatsApp Support
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }

          {activeTab === 'trips' &&
          <div className="space-y-6">
              <div className="flex flex-col md:flex-row gap-4">
                <div className="flex-1">
                  <Input
                  type="search"
                  placeholder="Search by booking ID, route, or destination..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e?.target?.value)} />

                </div>
                <div className="w-full md:w-64">
                  <Select
                  options={statusOptions}
                  value={filterStatus}
                  onChange={setFilterStatus}
                  placeholder="Filter by status" />

                </div>
              </div>

              <div className="space-y-4">
                {filteredTrips?.length > 0 ?
              filteredTrips?.map((trip) =>
              <TripCard
                key={trip?.id}
                trip={trip}
                onModify={handleModifyTrip}
                onCancel={handleCancelTrip} />

              ) :

              <div className="bg-card border border-border rounded-xl p-12 text-center">
                    <div className="w-16 h-16 rounded-full bg-muted mx-auto mb-4 flex items-center justify-center">
                      <Icon name="Search" size={32} className="text-muted-foreground" />
                    </div>
                    <h3 className="text-lg font-semibold text-foreground mb-2">
                      No trips found
                    </h3>
                    <p className="text-sm text-muted-foreground mb-6">
                      Try adjusting your search or filter criteria
                    </p>
                    <Button
                  variant="default"
                  onClick={() => {
                    setSearchQuery('');
                    setFilterStatus('all');
                  }}>

                      Clear Filters
                    </Button>
                  </div>
              }
              </div>
            </div>
          }

          {activeTab === 'saved' &&
          <div className="space-y-6">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground mb-2">
                    Saved Routes
                  </h2>
                  <p className="text-sm text-muted-foreground">
                    Quick access to your frequently traveled routes
                  </p>
                </div>
                <Button
                variant="default"
                size="default"
                iconName="Plus"
                iconPosition="left"
                onClick={() => navigate('/route-details')}>

                  Add Route
                </Button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
                {savedRoutes?.map((route) =>
              <SavedRouteCard
                key={route?.id}
                route={route}
                onRemove={handleRemoveSavedRoute} />

              )}
              </div>
            </div>
          }

          {activeTab === 'payments' &&
          <div className="space-y-6">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground mb-2">
                  Payment History
                </h2>
                <p className="text-sm text-muted-foreground">
                  View and download receipts for all your transactions
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
                {paymentHistory?.map((payment) =>
              <PaymentHistoryCard key={payment?.id} payment={payment} />
              )}
              </div>
            </div>
          }

          {activeTab === 'profile' &&
          <div className="space-y-6">
              <ProfileSection
              profile={userProfile}
              onUpdate={handleUpdateProfile} />


              <div className="bg-card border border-border rounded-xl p-6">
                <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
                  Notification Preferences
                </h3>
                <div className="space-y-4">
                  <div className="flex items-center justify-between p-4 rounded-lg bg-muted/50">
                    <div className="flex items-center gap-3">
                      <Icon name="Mail" size={20} className="text-primary" />
                      <div>
                        <p className="text-sm font-medium text-foreground">Email Notifications</p>
                        <p className="text-xs text-muted-foreground">Receive booking updates via email</p>
                      </div>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input type="checkbox" className="sr-only peer" defaultChecked />
                      <div className="w-11 h-6 bg-muted peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
                    </label>
                  </div>

                  <div className="flex items-center justify-between p-4 rounded-lg bg-muted/50">
                    <div className="flex items-center gap-3">
                      <Icon name="MessageSquare" size={20} className="text-primary" />
                      <div>
                        <p className="text-sm font-medium text-foreground">SMS Notifications</p>
                        <p className="text-xs text-muted-foreground">Get trip reminders via SMS</p>
                      </div>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input type="checkbox" className="sr-only peer" defaultChecked />
                      <div className="w-11 h-6 bg-muted peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
                    </label>
                  </div>

                  <div className="flex items-center justify-between p-4 rounded-lg bg-muted/50">
                    <div className="flex items-center gap-3">
                      <Icon name="Bell" size={20} className="text-primary" />
                      <div>
                        <p className="text-sm font-medium text-foreground">Push Notifications</p>
                        <p className="text-xs text-muted-foreground">Real-time updates on your device</p>
                      </div>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input type="checkbox" className="sr-only peer" defaultChecked />
                      <div className="w-11 h-6 bg-muted peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </main>
      <Footer />
    </div>);

};

export default UserDashboard;